module.exports = __webpack_public_path__ + "img/expect.cc482785.jpg";